import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { ProjectResolver } from '@/features/shell/project-resolver';

/**
 * `/$tenant/overview` — point d'entrée après connexion. La vue d'ensemble est celle d'un PROJET :
 * cette route redirige vers `/$tenant/projects/$projectId` (dernier projet ouvert, sinon le
 * premier), ou montre l'état vide d'un tenant qui n'a encore aucun projet.
 */
export const Route = createFileRoute('/$tenant/overview')({ component: OverviewRoute });

function OverviewRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="overview" crumbs={[{ label: t('nav.items.overview') }]}>
      <ProjectResolver tenantId={tenant} section="overview" />
    </ConsoleShell>
  );
}
